<script setup>
import { useAlertDialog } from '@/utils/stores/alertDialog'
import { useLoading } from '@/utils/stores/loading'
import { useProjectStore } from '@/utils/stores/project'
import { useSnackBar } from '@/utils/stores/snackbar'

const alertDialogStore = useAlertDialog()
const snackbarStore = useSnackBar()

definePage({
  meta: {
    action: 'read',
    subject: 'data-document',
  },
})

const loadingStore = useLoading()
const projectStore = useProjectStore()
const { projectName } = storeToRefs(projectStore)

const fetchSiteAll = async () => {
  const {
    data,
    execute: fetchSiteAll,
  } = await useApi(createUrl('/sources/sites/all', {
    query: {
      projectId: getProjectId(),
    },
  }))

  if(data) sites.value = [{ id: 0, name: "전체" }, ...data.value]
}

fetchSiteAll()

const siteId = ref()
const sites = ref([])
const subjects = ref([])
const subjectIds = ref([])

const fetchSubjects = async () => {
  const {
    data,
  } = await useApi(createUrl('/subjects/subject-list', {
    query: {
      siteId: siteId.value,
      projectId: getProjectId(),
    },
  }))

  if(data) subjects.value = data.value
}

const downloadExcel = async () => {
  loadingStore.message = "요청중... 기다려주세요."
  loadingStore.isLoading = true

  const ids = subjectIds.value.map(item => item.id)

  const data = await $api(`/excel/export`, { method: 'POST',
    // responseType: "blob",
    body: {
      subjectIds: ids,
      siteId: siteId.value,
      projectId: getProjectId(),
    },

    // timeout: 5 * 60 * 1000,
    // onResponseError({ response }) {
    //   loadingStore.isLoading = false
    //   snackbarStore.showSnackBar("오류가 발생하였습니다.", "error")
    // },
  })

  // const url = window.URL.createObjectURL(new Blob([data]))
  // const link = document.createElement('a')

  // link.href = url
  // link.setAttribute('download', "export.xlsx")
  // document.body.appendChild(link)
  // link.click()
  // window.URL.revokeObjectURL(url)
  // link.remove()
  loadingStore.isLoading = false
  alertDialogStore.showAlertDialog("요청이 완료되었습니다. 결과는 이메일로 전달됩니다.")
}

watch(()=>siteId.value, (n, o) => {
  subjectIds.value = []
  fetchSubjects()
})
</script>

<template>
  <VCard>
    <VCardText>
      <VRow>
        <VCol
          cols="2"
          class="d-flex align-center"
        >
          {{ $t('Project Name') }}
        </VCol>
        <VCol cols="10">
          {{ projectName }}
        </VCol>
        <VCol
          cols="2"
          class="d-flex align-center"
        >
          {{ $t('Site') }}
        </VCol>
        <VCol cols="10">
          <AppSelect
            v-model="siteId"
            :items="sites"
            item-title="name"
            item-value="id"
            placeholder="전체"
          />
        </VCol>
        <VCol
          cols="2"
          class="d-flex align-center"
        >
          {{ $t('Subject') }}
        </VCol>
        <VCol cols="10">
          <AppCombobox
            v-model="subjectIds"
            :items="subjects"
            item-title="name"
            item-value="id"
            multiple
            placeholder="전체"
            clearable
          />
        </VCol>
      </VRow>
    </VCardText>
  </VCard>
  <VRow class="mt-2">
    <VCol>
      <VBtn @click="downloadExcel">
        Download<VIcon
          end
          icon="tabler-file-spreadsheet"
        />
      </VBtn>
    </VCol>
  </VRow>
</template>
